// keyStyles: the receipts module's focus ring. Its keys are the kit's (ui/Button);
// a few hand-built controls (Pager's page keys, MatchPicker's cards, the reconcile
// board's rows) still carry this ring on their own.

/** The keyboard focus ring every key in the module carries. */
export const FOCUS = 'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/50';
